import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight, X, Expand } from "lucide-react";
import { fileUrl } from "@/lib/api";

export default function ImageGallery({ images = [], alt, children }) {
  const [i, setI] = useState(0);
  const [full, setFull] = useState(false);
  const n = images.length;
  const go = (d) => setI((x) => (x + d + n) % n);
  const onDragEnd = (_, info) => { if (info.offset.x < -50) go(1); else if (info.offset.x > 50) go(-1); };

  return (
    <div data-testid="image-gallery">
      <div className="relative h-80 w-full overflow-hidden bg-black">
        <AnimatePresence initial={false} mode="popLayout">
          <motion.img key={i} src={fileUrl(images[i])} alt={alt} drag={n > 1 ? "x" : false} dragConstraints={{ left: 0, right: 0 }}
                      onDragEnd={onDragEnd} onClick={() => setFull(true)} data-testid="gallery-image"
                      initial={{ opacity: 0, scale: 1.03 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0 }}
                      transition={{ duration: 0.25 }} className="h-80 w-full cursor-zoom-in object-cover" />
        </AnimatePresence>
        {n > 1 && (
          <>
            <button onClick={() => go(-1)} data-testid="gallery-prev" className="glass pressable absolute left-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full"><ChevronLeft size={18} color="#fff" /></button>
            <button onClick={() => go(1)} data-testid="gallery-next" className="glass pressable absolute right-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full"><ChevronRight size={18} color="#fff" /></button>
          </>
        )}
        <span className="glass absolute bottom-4 right-4 flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold text-white" data-testid="gallery-counter">
          <Expand size={12} /> {i + 1} / {n}
        </span>
        {children}
      </div>
      {n > 1 && (
        <div className="no-scrollbar flex gap-2 overflow-x-auto px-4 pt-3">
          {images.map((src, x) => (
            <button key={x} onClick={() => setI(x)} data-testid={`gallery-thumb-${x}`}
                    className="pressable h-14 w-14 shrink-0 overflow-hidden rounded-xl border-2 transition-opacity"
                    style={{ borderColor: x === i ? "var(--accent)" : "transparent", opacity: x === i ? 1 : 0.55 }}>
              <img src={fileUrl(src)} alt="" className="h-full w-full object-cover" />
            </button>
          ))}
        </div>
      )}
      <AnimatePresence>
        {full && (
          <motion.div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/95" data-testid="gallery-lightbox"
                      initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
            <img src={fileUrl(images[i])} alt={alt} className="max-h-[88vh] max-w-full object-contain" />
            <button onClick={() => setFull(false)} data-testid="gallery-close" className="glass pressable absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full"><X size={18} color="#fff" /></button>
            {n > 1 && (
              <>
                <button onClick={() => go(-1)} className="glass pressable absolute left-3 top-1/2 flex h-10 w-10 items-center justify-center rounded-full"><ChevronLeft size={20} color="#fff" /></button>
                <button onClick={() => go(1)} className="glass pressable absolute right-3 top-1/2 flex h-10 w-10 items-center justify-center rounded-full"><ChevronRight size={20} color="#fff" /></button>
              </>
            )}
            <span className="absolute bottom-6 text-sm font-bold text-white/80">{i + 1} / {n}</span>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
